import Slider from "./slider";

export default function (el) {
    const swiper = Slider(el);

    if(!swiper) return;
    
    el.classList.add(`ft--active-${swiper.realIndex + 1}`);

    swiper.on("slideChange", () => {
        el.classList.remove(`ft--active-${swiper.previousIndex + 1}`);
        el.classList.add(`ft--active-${swiper.realIndex + 1}`);
    });
}